import "../styles/report.css";
import { ExecSummaryNav } from "../components/report/ExecSummaryNav";
import { ExecSummaryHero } from "../components/report/ExecSummaryHero";
import { ExecSummaryBody } from "../components/report/ExecSummaryBody";
import { ReportFooter } from "../components/report/ReportFooter";

export default function ExecutiveSummary() {
  return (
    <div className="report-root" data-testid="executive-summary-page">
      <ExecSummaryNav />
      <ExecSummaryHero />
      <ExecSummaryBody />
      <ReportFooter />
    </div>
  );
}
